import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { useLenis } from "@/hooks/useLenis";
import { Grain } from "@/components/Grain";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { CategoryTiles } from "@/components/CategoryTiles";
import { Products } from "@/components/Products";
import { Bestsellers } from "@/components/Bestsellers";
import { TrustBadges } from "@/components/TrustBadges";
import { Manifesto } from "@/components/Manifesto";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { CartSheet } from "@/components/CartSheet";
import { AuthModal } from "@/components/AuthModal";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import OrdersPage from "@/pages/OrdersPage";
import AccountPage from "@/pages/AccountPage";
import ShopPage from "@/pages/ShopPage";
import CategoryPage from "@/pages/CategoryPage";
import ProductPage from "@/pages/ProductPage";
import {
    AboutPage,
    FAQPage,
    StoragePage,
    ShippingPage,
    PrivacyPage,
    TermsPage,
    ContactHelpPage,
} from "@/components/StaticPage";

const HomePage = () => {
    useLenis();
    return (
        <div className="App relative" data-testid="app-root">
            <Grain />
            <Header />
            {/*
              Mobile order (jars-first): Marquee → Products → Hero → CategoryTiles → Bestsellers → TrustBadges → Manifesto → Testimonials → Contact
              Desktop order (default):   Hero → Marquee → CategoryTiles → Bestsellers → TrustBadges → Products → Manifesto → Testimonials → Contact
            */}
            <main className="flex flex-col">
                <div className="order-3 md:order-1"><Hero /></div>
                <div className="order-1 md:order-2"><Marquee /></div>
                <div className="order-4 md:order-3"><CategoryTiles /></div>
                <div className="order-5 md:order-4"><Bestsellers /></div>
                <div className="order-6 md:order-5"><TrustBadges /></div>
                <div className="order-2 md:order-6"><Products /></div>
                <div className="order-7 md:order-7"><Manifesto /></div>
                <div className="order-8 md:order-8"><Testimonials /></div>
                <div className="order-9 md:order-9"><Contact /></div>
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
};

function App() {
    return (
        <LanguageProvider>
            <AuthProvider>
                <CartProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/shop" element={<ShopPage />} />
                            <Route path="/category/:cat" element={<CategoryPage />} />
                            <Route path="/product/:slug" element={<ProductPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/storage-guide" element={<StoragePage />} />
                            <Route path="/shipping" element={<ShippingPage />} />
                            <Route path="/privacy" element={<PrivacyPage />} />
                            <Route path="/terms" element={<TermsPage />} />
                            <Route path="/contact" element={<ContactHelpPage />} />
                            <Route path="/orders" element={<OrdersPage />} />
                            <Route path="/account" element={<AccountPage />} />
                        </Routes>
                        <AuthModal />
                        <CartSheet />
                    </BrowserRouter>
                </CartProvider>
            </AuthProvider>
        </LanguageProvider>
    );
}

export default App;
